export default __webpack_public_path__ + "static/media/VictorSE - Cyberpunk.8df0758a.mp3";